import { Box } from '@material-ui/core';
import { Agent, UserType } from '@nemuru-eng/js-api-client';

import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { UserListColumn } from '@/components/shared/components/UserList/types/TableProps';
import { UserList } from '@/components/shared/components/UserList/UserList';
import { ModuleCorePermissionProps, PendingDataType } from '@/config/types';

interface AgentsCredentialsTableProps extends ModuleCorePermissionProps {
  agents?: Agent[];
}

export const AgentsCredentialsTable = ({ canEdit, agents }: AgentsCredentialsTableProps) => {
  if (!agents || agents.length === 0)
    return (
      <Box mt={'84px'}>
        <PendingDataWarning type={PendingDataType.NO_AGENTS_IN_CHANNEL} />
      </Box>
    );

  return (
    <UserList
      editModeAllowed={canEdit}
      userIds={agents.map((agent) => agent.id)}
      userType={UserType.AGENT}
      hideSubsectionWrapper={true}
      tableProps={{ users: agents, columnsToHide: [UserListColumn.ICON, UserListColumn.ROLES] }}
    />
  );
};
